<div class="_client-statistics-component">

    <div class="_statistic-filters">
        <statistic-filter-component [params]="params" [paramsChanged]="paramsChanged" [filters]="filters"></statistic-filter-component>
	</div>	

    <div class="_statistic-components">
        <div class="_statistic-total">
            <clients-count-statistic-component [params]="params" [paramsChanged]="paramsChanged"></clients-count-statistic-component>
        </div>
    
        <div class="_statistics-container">
            <div class="_statistic-container">
                <clients-on-zipcodes-statistic-component [params]="params" [paramsChanged]="paramsChanged"></clients-on-zipcodes-statistic-component>
            </div>
            <div class="_statistic-container">
                <clients-on-target-audiences-statistic-component [params]="params" [paramsChanged]="paramsChanged"></clients-on-target-audiences-statistic-component>
            </div>
            <div class="_statistic-container">
                <clients-on-genders-statistic-component [params]="params" [paramsChanged]="paramsChanged"></clients-on-genders-statistic-component>
            </div>
            <div class="_statistic-container">
                <clients-on-origins-statistic-component [params]="params" [paramsChanged]="paramsChanged"></clients-on-origins-statistic-component>
            </div>
            <div class="_statistic-container">
                <clients-on-age-categories-statistic-component [params]="params" [paramsChanged]="paramsChanged"></clients-on-age-categories-statistic-component>
            </div>
            <div class="_statistic-container">
                <clients-on-devices-statistic-component [params]="params" [paramsChanged]="paramsChanged"></clients-on-devices-statistic-component>
            </div>
            <div class="_statistic-container">
                <clients-on-attendances-count-statistic-component [params]="params" [paramsChanged]="paramsChanged"></clients-on-attendances-count-statistic-component>
            </div>
        </div>
    </div>

    
	

</div>



